import logo from './LogoBurnCube.png';
import './App.scss';
import DztImageGalleryComponent from './components/gallery';

function App() {
  var data = [{
    url: 'https://play.google.com/store/apps/details?id=net.cue.vee.galaxter',
    title: 'World Destroyer',
    thumbUrl: 'images/wdiconplaystore.png',
  },
  {
    url: 'https://play.google.com/store/apps/details?id=net.cue.vee.agame',
    title: 'Rolling Eyeball',
    thumbUrl: 'images/eyeball.png',
  },
  {
    url: 'https://play.google.com/store/apps/details?id=com.cuevee.Allnightman',
    title: 'All-night-man',
    thumbUrl: 'images/anmscreen.png',
  },
  {
    url: 'https://play.google.com/store/apps/details?id=com.burn.cube.games.JutsuLegendFree',
    title: 'Jutsu Legend',
    thumbUrl: 'images/jutsu.jpg',
  },
  {
    url: 'https://play.google.com/store/apps/details?id=net.cuee.vee.halfcourt',
    title: 'Last2Minutes',
    thumbUrl: 'images/last2.webp',
  },
];

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          BURN CUBE GAMES
        </p>
      </header>
      <div>
      <DztImageGalleryComponent 
          images={data} />
      </div>
    </div>
  );
}

export default App;
